<accordion [isAnimated]="true" closeOthers="true">
  <accordion-group [isOpen]="hint.isExpanded" *ngFor="let hint of formPage.hints; let i = index" (click)="hint.isExpanded = !hint.isExpanded">
    <div accordion-heading>
              <span class="d-flex justify-content-between" style="color: white">{{ hint.title }}
                <i class="mt-1 float-end" [ngClass]="hint.isExpanded ? 'fas fa-minus' : 'fas fa-plus'"></i>
              </span>
    </div>
    <div (click)="$event.stopPropagation()">
      <p style="color: black" [innerHTML]="hint.html"></p>
      <img style="max-width: 100%; height: auto;" [src]="hint.image" alt="">
    </div>
  </accordion-group>
</accordion>
